import { render, staticRenderFns } from "./EV3VFormDisplay.vue?vue&type=template&id=1bd422fc&scoped=true"
import script from "./EV3VFormDisplay.vue?vue&type=script&lang=js"
export * from "./EV3VFormDisplay.vue?vue&type=script&lang=js"
import style0 from "./EV3VFormDisplay.vue?vue&type=style&index=0&id=1bd422fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd422fc",
  null
  
)

export default component.exports